import { useEffect, useRef } from "react";
import { API_URL } from "@/lib/api";

/**
 * Subscribe to a thread's SSE stream.
 * @param {string|null} threadId
 * @param {(evt: {kind: string, payload: any, at: string}) => void} onEvent
 * @param {boolean} isPublic — if true, use the public endpoint (no auth), and the payload is sanitized server-side
 */
export function useThreadStream(threadId, onEvent, isPublic = false) {
  const cbRef = useRef(onEvent);
  useEffect(() => { cbRef.current = onEvent; }, [onEvent]);

  useEffect(() => {
    if (!threadId) return;
    const base = isPublic
      ? `${API_URL}/relay/public/thread/${threadId}/stream`
      : `${API_URL}/relay/threads/${threadId}/stream`;
    const token = localStorage.getItem("oz_token");
    const url = isPublic ? base : `${base}?token=${encodeURIComponent(token || "")}`;
    const es = new EventSource(url);

    const handler = (kind) => (e) => {
      try {
        const data = JSON.parse(e.data);
        cbRef.current?.({ kind, ...data });
      } catch { /* ignore */ }
    };

    es.addEventListener("message", handler("message"));
    es.addEventListener("message_updated", handler("message_updated"));
    es.addEventListener("ping", () => {});
    es.onerror = () => { /* browser auto-reconnects */ };

    return () => es.close();
  }, [threadId, isPublic]);
}
